import { ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useModalContext } from "@hooks/contexts/modal-context";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { htmlFeeExternal } from "./financial/feeExternal";
import { ModalInfoHtml } from "../modal-info/indexHtml";
import { htmlInflow } from "./financial/Inflow";
import { htmlCommission } from "./financial/Commission";
import { htmlFeeInternal } from "./financial/feeInternal";
import { htmlProfit } from "./financial/Profit";
import { htmlFeeAnother } from "./financial/feeAnother";
import { htmlCampaignAcquisition } from "./financial/CampaignAcquisition";

interface IProps {
  messageKey: string;
  onClose: () => void;
}

interface IModalDefaultMessageHeaderDTO {
  [messageKey: string]: IModalDefaultMessageDTO;
}

interface IModalDefaultMessageDTO {
  header: string;
  title: string;
  html: ReactNode;
}

export function ModalDefaultMessage({ messageKey, onClose }: IProps) {
  const modalInfoList: IModalDefaultMessageHeaderDTO = {
    feeInternal: {
      header: "Taxas Internas (Plataforma)",
      title: "São taxas de serviços e/ou parcerias da Plataforma.",
      html: htmlFeeInternal(),
    },
    feeExternal: {
      header: "Taxas Externas",
      title: "São taxas de serviços de terceiros (fora da plataforma).",
      html: htmlFeeExternal(),
    },
    feeAnother: {
      header: "Outras Taxas / Impostos",
      title:
        "São taxas e/ou Impostos de serviços de terceiros (fora da plataforma).",
      html: htmlFeeAnother(),
    },
    Inflow: {
      header: "Entrada de Recursos",
      title: "Trata-se de todas Entradas de Valores em sua conta.",
      html: htmlInflow(),
    },
    Commission: {
      header: "Comissionamento",
      title: "Trata-se de incentivos pela divulgação de Campanhas e Usuários.",
      html: htmlCommission(),
    },
    Profit: {
      header: "Saldo Líquido",
      title:
        "Trata-se do saldo líquido das operações, após o desconto de taxas, comissões e encargos.",
      html: htmlProfit(),
    },
    campaignAcquisition: {
      header: "Aquisição de Campanha",
      title:
        "Trata-se da Taxa de criação de uma nova Campanha.",
      html: htmlCampaignAcquisition(),
    },
  };

  const location = useLocation();
  const { changeHash } = useModalContext();
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  const [modalInfo, setModalInfo] = useState<IModalDefaultMessageDTO>({
    header: ``,
    title: ``,
    html: ``,
  });

  function getModalInfo(param: string) {
    const info = modalInfoList[param];
    if (!info) {
      pushToastify({
        message: `Houve um erro ao carregar as informações.`,
        type: "warning",
        theme: "dark",
      });
      return;
    }

    setModalInfo({
      header: info.header,
      title: info.title,
      html: info.html,
    });

    OpenModal();
  }

  function OpenModal() {
    changeHash("modalInfo");
  }

  useEffect(() => {
    getModalInfo(messageKey);
  }, [location.hash, messageKey]);

  return (
    <>
      <ModalInfoHtml
        header={modalInfo.header}
        title={modalInfo.title}
        html={modalInfo.html}
        isOpen={location?.hash === "#modalInfo"}
        onClose={() => {
          changeHash("");
          onClose();
        }}
      />
    </>
  );
}
